import produce from "immer";
import {
  FETCH_WEBSITE,
  FETCH_WEBSITE_SUCCESS,
  FETCH_WEBSITE_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_WEBSITE,
  ADD_WEBSITE_SUCCESS,
  ADD_WEBSITE_FAILURE,
  //
  EDIT_WEBSITE,
  EDIT_WEBSITE_SUCCESS,
  EDIT_WEBSITE_FAILURE,
  //
  DELETE_WEBSITE,
  DELETE_WEBSITE_SUCCESS,
  DELETE_WEBSITE_FAILURE,
  //
  OPEN_WEBSITE_ADD_MODAL,
  CLOSE_WEBSITE_ADD_MODAL,
  //
  OPEN_WEBSITE_EDIT_MODAL,
  SET_EDIT_SUCCESS,
  SET_EDIT_FAILURE,
  CLOSE_WEBSITE_EDIT_MODAL,
} from "./constants";

export const initialState = {
  isFetchingWebsite: false,
  Websites: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  isAddModalOpen: false,
  //
  isEditModalOpen: false,
  currentWebsite: {},
  isFetchingCurrentWebsite: false,
};

const WebsiteReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_WEBSITE:
        draft.isFetchingWebsite = true;
        draft.currentWebsite = {};
        draft.Websites = [];
        break;
      case FETCH_WEBSITE_SUCCESS:
        draft.isFetchingWebsite = false;
        draft.Websites = action.payload;
        break;
      case FETCH_WEBSITE_FAILURE:
        draft.isFetchingWebsite = false;
        draft.Websites = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentWebsite = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentWebsite = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_WEBSITE:
        draft.isSubmitting = true;
        break;
      case ADD_WEBSITE_SUCCESS:
        draft.isSubmitting = false;
        draft.isAddModalOpen = false;
        break;
      case ADD_WEBSITE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_WEBSITE:
        draft.isSubmitting = true;
        break;
      case EDIT_WEBSITE_SUCCESS:
        draft.isSubmitting = false;
        draft.isEditModalOpen = false;
        break;
      case EDIT_WEBSITE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_WEBSITE:
        draft.isDeleting = true;
        break;
      case DELETE_WEBSITE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_WEBSITE_FAILURE:
        draft.isDeleting = false;
        break;

      case OPEN_WEBSITE_ADD_MODAL:
        draft.isAddModalOpen = true;
        break;
      case CLOSE_WEBSITE_ADD_MODAL:
        draft.isAddModalOpen = false;
        break;

      case OPEN_WEBSITE_EDIT_MODAL:
        draft.isEditModalOpen = true;
        draft.isFetchingCurrentWebsite = true;
        break;
      case SET_EDIT_SUCCESS:
        draft.currentWebsite = action.payload;
        draft.isFetchingCurrentWebsite = false;
        break;
      case SET_EDIT_FAILURE:
        draft.currentWebsite = {};
        draft.isFetchingCurrentWebsite = false;
        break;
      case CLOSE_WEBSITE_EDIT_MODAL:
        draft.isEditModalOpen = false;
        draft.currentWebsite = {};
        break;

      default:
        return state;
    }
  });

export default WebsiteReducer;
